import type { FetchPolicy } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery';
import { useExperimentalQueryBase } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQueryBase';
import { experimentalMacroMetadata } from '@confluence/graphql/entry-points/experimentalMacroMetadata';
import type { ResolverContext } from '@confluence/graphql/entry-points/ResolverContext';
import { cfetch } from '@confluence/network';

import type {
	ExcerptIncludeQuery as ExcerptIncludeQueryData,
	ExcerptIncludeQueryVariables,
} from './__types__/ExcerptIncludeQuery';

export const useExperimentalMacroMetadataQuery = ({
	variables,
	skip = false,
	fetchPolicy = 'cache-first',
}: {
	variables: ExcerptIncludeQueryVariables;
	skip?: boolean;
	fetchPolicy?: FetchPolicy;
}) => {
	const fetchData = async (): Promise<ExcerptIncludeQueryData> => {
		const result = await experimentalMacroMetadata({}, variables, {
			network: { cfetch } as unknown as ResolverContext['network'],
		});

		return {
			experimentalMacroMetadata: result
				? {
						payload: result.payload ?? null,
						contentId: result.contentId ?? null,
					}
				: null,
		};
	};

	const key = JSON.stringify({ query: 'experimentalMacroMetadata', variables });

	return useExperimentalQueryBase<ExcerptIncludeQueryData, ExcerptIncludeQueryVariables>({
		key,
		fetchData,
		variables,
		skip,
		fetchPolicy,
	});
};
